// Copyright (C) 2019 TANNER AG

import gql from "graphql-tag";

export const tcoCompareMutation = gql`
    mutation tcoCompare($busAParams: TcoCalculationParams, $busBParams: TcoCalculationParams) {
        tcoCompare(busAParams: $busAParams, busBParams: $busBParams) {
            percentageDifference
            totalDifference
            bus
            calculations {
                bus
                fuelCosts
                maintenanceCost
            }
        }
    }
`;

export const lccCompareMutation = gql`
    mutation tcoCompare($busAParams: LccCalculationParams, $busBParams: LccCalculationParams) {
        lccCompare(busAParams: $busAParams, busBParams: $busBParams) {
            percentageDifference
            totalDifference
            bus
            calculations {
                bus
                fuelCosts
                maintenanceCost
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/tco/queries/compare.js